import { ReactNode } from 'react';

export interface FeatureFlashContent {
  id: string;
  title: string;
  content: ReactNode;
}

export const FEATURE_FLASH_CONTENTS: FeatureFlashContent[] = [
  {
    id: 'promote-mentor',
    title: 'Feature Flash',
    content: (
      <>
        Use the <strong>Promote</strong> and <strong>Demote</strong> buttons in User Management - Users Overview to manage mentor roles. For best results, set the correct user status when creating new users!
      </>
    ),
  },
  {
    id: 'connection-matching',
    title: 'Feature Flash',
    content: (
      <>
        Our AI pairs users based on shared interests, education, and professional expertise. Tip: richer profiles lead to better matches!
      </>
    ),
  },
  {
    id: 'intro-stats',
    title: 'Feature Flash',
    content: (
      <>
        Monitor your AI introduction performance in the <strong>Intros Dashboard</strong> to track success rates and NPS score.
      </>
    ),
  },
  {
    id: 'data-request',
    title: 'Feature Flash',
    content: (
      <>
        Need specific data exports? Use the <strong>Data Request</strong> link at the bottom of the sidebar to submit custom report requests.
      </>
    ),
  },
  {
    id: 'add-users-via-file',
    title: 'Feature Flash',
    content: (
      <>
        Upload a CSV file to create multiple user accounts. <strong>Latte AI</strong> automatically processes and enhances the data to create rich profiles with structured information for better connections.
      </>
    ),
  },
];

export const getRandomFeatureFlash = (): FeatureFlashContent => {
  const randomIndex = Math.floor(Math.random() * FEATURE_FLASH_CONTENTS.length);
  return FEATURE_FLASH_CONTENTS[randomIndex];
};
